import { Link } from 'react-router-dom'
import { Card } from '@/shared/components/atoms/ui/card'
import { useDashboard } from '../hooks/useDashboard'

interface QuickLink {
	label: string
	href: string
}

const LINKS: QuickLink[] = [
	{ label: 'Request Types', href: '/admin/request-center/types' },
	{ label: 'Data Sources', href: '/admin/request-center/data-sources' },
	{ label: 'Systems', href: '/admin/request-center/systems' },
	{ label: 'Audit Search', href: '/admin/request-center/audit' },
]

/**
 * Admin-only Quick Links — static shortcuts to the Request Center
 * admin pages. No data fetches; just navigation.
 *
 * Spec 4 / Group 9f — `request-center-dashboard.md`.
 */
export function QuickLinksWidget() {
	const { isAdminViewer } = useDashboard()
	if (!isAdminViewer) return null

	return (
		<Card className="p-4">
			<h2 className="mb-3 text-sm font-semibold text-foreground">Quick Links</h2>
			<ul className="grid grid-cols-2 gap-2">
				{LINKS.map((l) => (
					<li key={l.href}>
						<Link
							to={l.href}
							className="block rounded-md border border-border bg-white px-3 py-2 text-sm font-medium text-foreground hover:border-border hover:bg-muted"
						>
							{l.label}
						</Link>
					</li>
				))}
			</ul>
		</Card>
	)
}
